import FlexBox from "@/components/layout/FlexBox"

const Style = {
  token: {fontWeight: 600},
  disclaimer: {marginTop: 4}
}

// Guard at the call site (hintMessage={token && <TokenHint .../>}): an element is
// truthy even when it renders nothing, so an unguarded pass draws an empty card
export const TokenHint = ({token}) => (
  <FlexBox column>
    <FlexBox style={Style.token}>Token: {token}</FlexBox>
    <FlexBox style={Style.disclaimer}>
      This token is confidential and for support purposes only
    </FlexBox>
  </FlexBox>
)
